export const STORAGE_KEYS = {
  LOTS: 'lotlingo.portal.lots.v1',
  AUTH: 'lotlingo.portal.auth',
  PENDING_PROFILE: 'll_portal_pending_profile',
  SETTINGS: 'lotlingo.portal.settings.v1',
  VIEW_MODE: 'lotlingo.portal.viewMode',
  CUSTOM_CLOSE_TIMES: 'lotlingo.portal.customCloseTimes.v1',
  ESTIMATE_CACHE: 'lotlingo_last_estimate',
  LOGOUT_FLAG: 'lotlingo.portal.logoutFlag.v1',
};
